export const CONSTS = {
  HEADER: $localize`Logout`,
  CONFIRMATION: $localize`Are you sure you want to logout?`,
};
